// apps/web/src/ui/PageShell.tsx
import React from "react";
import { Header, HEADER } from "@/ui/Header";

type Props = {
    title: string;
    onBack?: () => void;
    backIcon?: string;
    icon?: string;
    onTitleClick?: () => void;
    onIconClick?: () => void;
    headerRight?: React.ReactNode;
    /** 1264 기준 레이아웃 폭. 숫자(px) 또는 문자열("1012px") */
    width?: number | string;
    /** 헤더 아래(body) 영역에 추가로 줄 스타일 */
    bodyStyle?: React.CSSProperties;
    /** 최상위 래퍼에 줄 스타일 */
    wrapperStyle?: React.CSSProperties;
    /** 헤더 높이(기본: HEADER.H) */
    headerHeight?: number;
};

export function PageShell({
                              title,
                              onBack,
                              backIcon,
                              icon,
                              onTitleClick,
                              onIconClick,
                              headerRight,
                              width,
                              bodyStyle,
                              wrapperStyle,
                              headerHeight,
                              children,
                          }: React.PropsWithChildren<Props>) {
    const headerH = headerHeight ?? HEADER.H;
    const targetWidth =
        typeof width === "number" ? `${width}px` : width ?? "100%";

    return (
        <div
            style={{
                width: "100%",
                minHeight: "var(--app-lvh, 100vh)",
                display: "flex",
                justifyContent: "center",
                overflow: "hidden",
                // 전체 앱 배경에 뭔가 주고 싶을 때 여기(wrapperStyle)
                ...wrapperStyle,
            }}
        >
            <div
                style={{
                    width: "100%",
                    maxWidth: targetWidth,   // ❗절대 100% 넘지 않게
                    margin: "0 auto",
                    display: "grid",
                    gridTemplateRows: `${headerH}px minmax(0, 1fr)`,
                    gridTemplateAreas: `"header" "body"`,
                    boxSizing: "border-box",
                    overflowX: "hidden",     // ❗혹시라도 넘치는 요소가 있어도 가로 스크롤 방지

                }}
            >
                <div style={{ gridArea: "header" }}>
                    <Header
                        title={title}
                        onBack={onBack}
                        backIcon={backIcon}
                        icon={icon}
                        right={headerRight}
                        onTitleClick={onTitleClick}
                        onIconClick={onIconClick}
                    />
                </div>
                <div style={{ gridArea: "body", ...bodyStyle }}>{children}</div>
            </div>
        </div>
    );
}
